import {
  FORECASTS,
  FORECASTING,
  LOADING,
  OPEN_MODAL,
  CREATE_FORECASTING,
  DELETE_FORECASTING
} from './ForecastingActions';

const INITIAL_STATE = {
  forecasts: [],
  loading: false,
  created: false,
  forecasting: undefined,
  activities: []
};

const ForecastingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FORECASTS: {
      return {
        ...state,
        loading: false,
        forecasts: action.data.forecasts
      };
    }
    case FORECASTING: {
      return {
        ...state,
        loading: false,
        forecasting: action.data.forecasting,
        activities: action.data.activities
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: action.val
      };
    }
    case OPEN_MODAL: {
      return {
        ...state,
        created: false
      };
    }
    case CREATE_FORECASTING: {
      return {
        ...state,
        created: true,
        loading: false
      };
    }
    case DELETE_FORECASTING: {
      return {
        ...state,
        loading: false
      };
    }
  }

  return state;
};

export default ForecastingReducer;
